import React, { useEffect, useState } from "react";

// Question interface
interface QuestionData {
    sentence: string;
    correctNoun: string;
    options: string[];
}

import { IonItem, IonLabel, IonRadio, IonRadioGroup } from "@ionic/react";

const NounsFillBlanks: React.FC = () => {
    const [questions, setQuestions] = useState<QuestionData[]>([]);
    const [selectedOption, setSelectedOption] = useState<string | null>(null);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState(false);

    // Fetch question data from an external source (replace with your actual API or JSON URL)
    const fetchQuestions = async () => {
        try {
            let data: QuestionData[] = [];

            if (process.env.REACT_APP_DEVELOPMENT !== 'WEB') {
                const response = await fetch(process.env.REACT_APP_API_URL + 'NounsFillBlanks.json');
                data = await response.json();
            } else {
                const module = await import('../../../datas/NounsFillBlanks.json');
                data = module.default;
            }

            const shuffledQuestions = shuffleArray(data);
            setQuestions(shuffledQuestions);
        } catch (error) {
            console.error('Error loading data:', error);
        }
    };

    useEffect(() => {
        // Simulating an API fetch to load questions
        fetchQuestions();
        document.title = "Mamas Guidance - Class Two - English - Noun – Naming Words - Fill in the blanks"; // Set page title
    }, []);

    const shuffleArray = (array: any[]) => {
        for (let i = array.length - 1; i > 0; i--) {
            const randomIndex = Math.floor(Math.random() * (i + 1));
            [array[i], array[randomIndex]] = [array[randomIndex], array[i]];
        }
        return array;
    };

    const handleOptionClick = (selectedMyOption: string) => {
        const currentQuestion = questions[currentIndex];
        setSelectedOption(selectedMyOption);
        if (selectedMyOption === currentQuestion.correctNoun) {
            setError(false);
            setShowImage(true);
            setTimeout(() => {
                const nextIndex = currentIndex + 1;
                if (nextIndex < questions.length) {
                    setCurrentIndex(nextIndex);
                }
                setShowImage(false);
                setError(false);
            }, 5000); // Shortened delay to 3 seconds
        } else {
            setError(true);
        }
    };

    return (
        <>
            {
                showImage === false ?
                    <>
                        <div className="contentPart englishStory additionWord">
                            <div className="mb-4">
                                <h4>
                                    {questions[currentIndex]?.sentence.replace(
                                        "___",
                                        "______"
                                    ) /* Display sentence */}
                                </h4>
                            </div>
                            <div className="grid-container" style={{marginBottom: "20px"}}>
                                <div className="grid-box d-none d-lg-block"></div>
                                <div className="grid-box optionDiv" style={{display: "block"}}>
                                    <IonRadioGroup onIonChange={(e) => handleOptionClick(e.detail.value)}>
                                        {questions[currentIndex]?.options.map((option, index) => (
                                            <IonItem key={index} className={`${selectedOption === option
                                                ? option === questions[currentIndex]?.correctNoun
                                                    ? 'correct'
                                                    : 'incorrect'
                                                : ''
                                                }`}>
                                                <IonLabel>{option}</IonLabel>
                                                <IonRadio slot="start" value={option} />
                                            </IonItem>
                                        ))}
                                    </IonRadioGroup>
                                </div>
                                <div className="grid-box d-none d-lg-block"></div>
                            </div>
                        </div>
                    </>
                    :
                    <>
                        <div className="contentPart showMiddle">
                            <img style={{ height: '150px' }} className='img-fluid' src={process.env.REACT_APP_WELDONE_LINK} />
                        </div>
                    </>
            }
        </>
    );
};

export default NounsFillBlanks;
